import { View } from 'backbone.marionette';
import _ from 'lodash';

/**
 *
 */
class CoreLeagueSetupView extends View {

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			form_switch:         '.js-form-switch',
			submit_form:         '.js-submit-league-form',
			league_form:         '.js-league-form',
			head_to_head_only:   '.js-head-to-head-only',
			league_name:         '.js-league-name',
			league_avatar:       '.js-league-avatar',
			privacy_settings:    '.js-privacy-settings',
			league_type:         '.js-league-type',
			league_size:         '.js-league-size',
			start_round:         '.js-start-round',
			bye_rounds:          '.js-bye-rounds',
			finals_format:       '.js-league-final-format',
			finals_start_round:   '.js-league-final-start-round',
			play_times:          '.js-play-times',
			coaches_box:         '.js-coaches-box',
			display_img:         '.js-display-img',
			form_error:          '.js-form-error',
			display_league_name: '.js-display-league-name'
		};
	}

	/**
	 *    Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			'click @ui.form_switch':    'formSwitch',
			'change @ui.league_form':   'updateForm',
			'change @ui.league_avatar': 'updateAvatar',
			'change @ui.league_name':   'updateDisplayName'
		};
	}

	/**
	 * Update league fields
	 */
	updateForm( event = {} ) {
		const name = event.target.name;

		this.setFormElements();
		this.model.validateLeague();

		if ( this.shouldPreventRender( $( event.target ) ) ) {
			return this;
		}

		this.model
			.updateFormData( this.rounds, true,  name )
			.updateUserName();
		this.updateView();
	}

	/**
	 *
	 * @returns {LeagueCreateView}
	 */
	setFormElements() {
		let form_elements = {
			name:          this.getUI( 'league_name' ).val(),
			league_avatar: '',
			privacy:       this.getUI( 'privacy_settings' ).filter( ':checked' ).val(),
			type:          this.getUI( 'league_type' ).filter( ':checked' ).val(),
			start_round:   parseInt(this.getUI( 'start_round' ).val(), 10),
			size:          parseInt(this.getUI( 'league_size' ).val(), 10),
			bye_rounds:    parseInt(this.getUI( 'bye_rounds' ).filter( ':checked' ).val(), 10),
			finals_format: this.getUI( 'finals_format' ).val(),
			finals_start_round: this.getUI( 'finals_start_round' ).val(),
			play_times:    this.getUI( 'play_times' ).filter( ':checked' ).val(),
			coaches_box:   this.getUI( 'coaches_box' ).filter( ':checked' ).val()
		};

		this.model.set( form_elements );

		return this;
	}

	shouldPreventRender( $target ) {
		const prevent_fields = _.values(
			_.pick( this.ui, [
				'league_name', 'league_avatar'
			] )
		);

		return prevent_fields.some(
			$field => $field.is( $target )
		);
	}

	updateAvatar( element ) {
		let reader = new FileReader(),
			image  = $( element.currentTarget ).get( 0 ).files[ 0 ];

		reader.onload = e => {
			this.getUI( 'display_img' ).attr( 'srcset', e.target.result );
			this.model.set( 'display_avatar', e.target.result );
		};

		reader.readAsDataURL( image );

		this.model.set( 'avatar', image );
	}

	updateDisplayName( element ) {
		let new_name = $( element.currentTarget ).val();
		this.getUI( 'display_league_name' ).text( new_name );
	}

	checkFormErrors( errors ) {
		this.getUI( 'form_error' ).removeClass( 'active' );

		_.each( errors, ( item, name ) => {
			$( '.' + name ).text( item[ 0 ] ).addClass( 'active' );
		} );
	}

	/**
	 *
	 * @param element
	 */
	formSwitch( element ) {
		element.preventDefault();

		let
			$form_switch = $( element.currentTarget ),
			current_val  = $form_switch.data( 'value' );

		this.model.set( 'advanced_options', current_val );
		this.updateView();
	}

	/**
	 * Update view after all fetch data
	 */
	updateView() {
		this.render();
	}

}

export default CoreLeagueSetupView;